module.exports = __webpack_public_path__ + "img/icn_forward.6807e77f.svg";